// src/components/Education/Education.js
import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <section className="education-container">
      <h2 className="education-title">Education & Certifications</h2>
      <p className="education-subtitle">
        A solid academic foundation in technology and full-stack development, complemented by industry-recognized certifications to fuel my career as a Full Stack Developer, Web Developer, and Email Developer.
      </p>

      <div className="education-list">
        {/* Education 1 */}
        <article className="education-item">
          <div className="education-icon">🎓</div>
          <div className="education-content">
            <h3 className="education-degree">Industry Ready Certification in Full-stack Development</h3>
            <p className="education-institution">Nxtwave Disruptive Technologies</p>
            <p className="education-duration">12/2021 - 05/2022</p>
            <p className="education-details">
              Specialized training in full-stack development, covering HTML, CSS, JavaScript, React.js, Node.js, Express.js, and SQLite, equipping me with the skills to build robust web applications.
            </p>
          </div>
        </article>

        {/* Education 2 */}
        <article className="education-item">
          <div className="education-icon">🎓</div>
          <div className="education-content">
            <h3 className="education-degree">Bachelor of Engineering in Electronics and Communication Engineering (ECE)</h3>
            <p className="education-institution">MeRITS, Nellore</p>
            <p className="education-duration">Completed 146 out of 176 credits |  05/2015 - 05/2019</p>
            <p className="education-details">
              Gained a strong foundation in electronics and communication principles, with coursework in programming, circuit design, and digital systems, fostering problem-solving and technical skills.
            </p>
          </div>
        </article>

        {/* Education 3 */}
        <article className="education-item">
          <div className="education-icon">📚</div>
          <div className="education-content">
            <h3 className="education-degree">Intermediate (MPC) - 80.04%</h3>
            <p className="education-institution">L.V.R Junior College, Nellore</p>
            <p className="education-duration">05/2013 - 04/2015</p>
            <p className="education-details">
              Focused on Mathematics, Physics, and Chemistry, achieving a strong academic record and building a foundation for technical education.
            </p>
          </div>
        </article>

        {/* Education 4 */}
        <article className="education-item">
          <div className="education-icon">📚</div>
          <div className="education-content">
            <h3 className="education-degree">Secondary School Certificate (SSC) - 9.3 CGPA</h3>
            <p className="education-institution">Gouthami High School, Nellore</p>
            <p className="education-duration">05/2012 - 04/2013</p>
            <p className="education-details">
              Excelled in core subjects, laying the groundwork for a career in technology with a strong academic performance.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Education;